"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _zippayBtn = _interopRequireDefault(require("./zippayBtn"));
var _reactIntl = require("react-intl");
var _fieldsMessages = require("../../fields/fieldsMessages");
var _commonUtils = require("../../../utils/commonUtils");
var _contexts = require("../../../contexts");
var _actions = require("../../../contexts/actions");
require("../../../style/zippay/main.css");
var _constants = require("../../../constants/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Zippay = function Zippay(props) {
  var inputCustomData = props.inputCustomData,
    customAuthCallBack = props.customAuthCallBack,
    customFunctions = props.customFunctions,
    setProcessing = props.setProcessing;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    zippayComponent = _useState2[0],
    setzippayComponent = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    scriptLoaded = _useState4[0],
    setScriptLoaded = _useState4[1];
  var _useContext = (0, _react.useContext)(_contexts.ZippayContext),
    merchantId = _useContext.state.merchantId;
  var _useContext2 = (0, _react.useContext)(_contexts.PaymentContext),
    cartAmount = _useContext2.state.cartAmount,
    paymentDispatch = _useContext2.dispatch;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var authCallHandler = function authCallHandler() {
    if (cartAmount < 35 || cartAmount > 500) {
      var zipPayMessage = document.querySelector('.zippay-container__message');
      if (zipPayMessage) {
        zipPayMessage.style.color = 'red';
      }
      return;
    }
    document.querySelector('#QPButton').click();
  };
  (0, _react.useEffect)(function () {
    if (!document.getElementById('ZipPayScript')) {
      var script = document.createElement('script');
      script.src = (0, _constants.getZipURL)(inputCustomData.environment);
      script.type = 'text/javascript';
      script.setAttribute('id', 'ZipPayScript');
      if (script.readyState) {
        // only required for IE <9
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            setScriptLoaded(true);
          }
        };
      } else {
        script.onload = function () {
          setScriptLoaded(true);
        };
      }
      document.head.appendChild(script);
    } else {
      setScriptLoaded(true);
    }
  }, []);
  (0, _react.useEffect)(function () {
    paymentDispatch((0, _actions.registerAuthCallHandler)({
      paymentMethod: _constants.PAYMENT_METHOD_ALIAS.ZIP_PAY,
      authCallHandler: authCallHandler
    }));
  }, [cartAmount]);
  function setupZipPay() {
    setzippayComponent( /*#__PURE__*/_react.default.createElement(_zippayBtn.default, {
      scriptLoaded: scriptLoaded,
      inputCustomData: inputCustomData,
      customAuthCallBack: customAuthCallBack,
      customFunctions: customFunctions,
      merchantId: merchantId,
      setProcessing: setProcessing
    }));
  }
  (0, _react.useEffect)(function () {
    if (merchantId && scriptLoaded) {
      if ((0, _commonUtils.isIe11)()) {
        document.addEventListener('WebComponentsReady', function () {
          setupZipPay();
        });
      } else {
        setupZipPay();
      }
    }
  }, [scriptLoaded]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "zippay-container"
  }, zippayComponent);
};
Zippay.propTypes = {
  inputCustomData: _propTypes.default.object.isRequired,
  customAuthCallBack: _propTypes.default.func.isRequired,
  customFunctions: _propTypes.default.object,
  setProcessing: _propTypes.default.func
};
var _default = Zippay;
exports.default = _default;